import React from 'react';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';
import { isValidArrayLength, isValidNumber, isValidString, } from '@nykaa/utils/validations';
import { Root, Wrapper, Image, Title, } from './styles';
const DifferentialPricing = ({ cohortSaleTemplate, }) => {
    var _a;
    const { textV2: title, gradientColors, borderRadius, crownImage, textColor, textTransparency, } = cohortSaleTemplate || {};
    if (!isValidString(title)
        && !isValidArrayLength(gradientColors)
        && !isValidString(crownImage)
        && !isValidNumber(borderRadius)) {
        return null;
    }
    const gradientData = gradientColors && ((_a = gradientColors === null || gradientColors === void 0 ? void 0 : gradientColors.map(({ color, transparency }) => `${hexToRgb(color, transparency)}`)) === null || _a === void 0 ? void 0 : _a.join(', '));
    const gradient = gradientData && `linear-gradient(to right, ${gradientData})`;
    return (React.createElement(Root, null,
        React.createElement(Wrapper, { borderRadius: borderRadius, gradient: gradient },
            React.createElement(Image, { src: crownImage, alt: "crownImage", "data-loading": "lazy" }),
            React.createElement(Title, { textColor: textColor, textTransparency: textTransparency }, title))));
};
export default DifferentialPricing;
